import workspace from "./workspace";

export const getAgentConfigs = async () => {
  try {
    const response = await workspace.get(`/agent-config/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching agent configs:", error);
    throw error;
  }
};

export const getAgentConfigById = async (id) => {
  try {
    const response = await workspace.get(`/agent-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching agent config with ID ${id}:`, error);
    throw error;
  }
};


export const getAgentConfigsByOrg = async (organizationId) => {
  try {
    const response = await workspace.get(`/agent-config/by-organization/${organizationId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching agent configs for org ${organizationId}:`, error);
    throw error;
  }
};


export const createAgentConfig = async (configData) => {
  try {
    const response = await workspace.post(`/agent-config/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error("Error creating agent config:", error);
    throw error;
  }
};

export const updateAgentConfig = async (id, configData) => {
  try {
    const response = await workspace.put(`/agent-config/${id}/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating agent config with ID ${id}:`, error);
    throw error;
  }
};

export const partialUpdateAgentConfig = async (id, configData) => {
  try {
    const response = await workspace.patch(`/agent-config/${id}/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error(`Error partially updating agent config with ID ${id}:`, error);
    throw error;
  }
};

export const deleteAgentConfig = async (id) => {
  try {
    const response = await workspace.delete(`/agent-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting agent config with ID ${id}:`, error);
    throw error;
  }
};

// Additional service methods for specific functionality

export const getActiveAgentConfigs = async () => {
  try {
    const response = await workspace.get(`/agent-config/`, {
      params: { is_active: true }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active agent configs:", error);
    throw error;
  }
};

export const testAgentConfig = async (id) => {
  try {
    const response = await workspace.post(`/agent-config/${id}/test/`);
    return response.data;
  } catch (error) {
    console.error(`Error testing agent config with ID ${id}:`, error);
    throw error;
  }
};

export const exportAgentConfig = async (id) => {
  try {
    const response = await workspace.get(`/agent-config/${id}/export/`);
    return response.data;
  } catch (error) {
    console.error(`Error exporting agent config with ID ${id}:`, error);
    throw error;
  }
};